var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.3 35.3",
    style: {
      enableBackground: "new 0 0 35.3 35.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33ADA3;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F28F39;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E8553F;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.8,29c3.1-2.8,5.1-6.9,5.1-11.4c0-4.5-2-8.6-5.1-11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,6.3c-3.1,2.8-5.1,6.9-5.1,11.4c0,4.5,2,8.6,5.1,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,24.1c1.9-1.5,3-3.9,3-6.5c0-2.5-1.1-4.8-2.9-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,11.2c-1.9,1.5-3,3.9-3,6.5c0,2.6,1.2,4.9,3,6.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17.6,
    cy: 17.6,
    r: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.9c499439d9e176ac2eb7b8479e4bcea7.svg";
export { ForwardRef as ReactComponent };